import type { LogTarget } from '@amazon/vinyl-util'
import { createDisposer, logDebug, throttle, type Unsubscribe } from '@amazon/vinyl-util'
import { isProbablyMobileData, onIsProbablyMobileDataChange } from '@/util/networkUtil'
import type { StreamingSettingsController } from './StreamingSettingsController'
import type { Player } from '@/playback/api'

const logTarget: LogTarget = {
    logPrefix: 'streamingQualityPlayerBinding',
}

export function bindStreamingQualityToPlayer(
    c: StreamingSettingsController,
    player: Player
): Unsubscribe {
    const disposer = createDisposer()
    const { add, dispose } = disposer
    const refreshPlayerSettings = add(
        throttle(
            () => {
                const settings = c.value
                logDebug(logTarget, 'refresh', settings)
                if (!settings) return
                const streamingQuality = isProbablyMobileData()
                    ? settings.streamingQualityMobile
                    : settings.streamingQuality
                const abrEnabled = settings.abrEnabled
                if (!disposer.disposed) {
                    player.setStreamingQuality(streamingQuality, abrEnabled)
                    player.configure({})
                }
            },
            0.2,
            {
                leading: true,
                trailing: true,
            }
        )
    )
    add(c.onData(refreshPlayerSettings))
    add(onIsProbablyMobileDataChange(refreshPlayerSettings))
    return dispose
}
